export const parseLocalizedName = (value, language, fallback = "N/A") => {
  if (!value) return fallback;
  if (typeof value !== "string") return value;

  try {
    if (!value.trim().startsWith("{")) {
      return value;
    }

    const parsed = JSON.parse(value);
    if (typeof parsed !== "object" || parsed === null) {
      return fallback;
    }

    return (
      parsed[language] ||
      parsed.en ||
      Object.values(parsed).find(Boolean) ||
      fallback
    );
  } catch {
    return fallback;
  }
};
